export default __webpack_public_path__ + "static/media/137sasset_2.b0264894.png";